import React, { useEffect, useState } from 'react'
import { Card, CardContent, Divider, Typography, Stack } from '@mui/material'
import { Helmet } from '@dr.pogodin/react-helmet'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { IssueStatusDescription } from '../../../../components/entities/IssueStatus'
import CreateIssueForm from '../AdminCreateIssueForm'
import { EditIssueForm } from './AdminEditIssueForm'
import { FormIssueEntity } from '../../types/FormIssueEntity'

function AdminIssueForm() {
    const { t } = useTranslation()
    const { issueId } = useParams()
    const [issue, setIssue] = useState<FormIssueEntity | null>(null)

    const handleChangeIssue = React.useCallback((issue: FormIssueEntity) => setIssue(issue), [setIssue])

    useEffect(() => {
        if (issueId === 'new') {
            setIssue(null)
        }
    }, [issueId]) // reset company name when creating a new issue

    return (
        <>
            <Helmet title={t('site.issues.detailsTitle', { name: issue?.companyName }) || ''} />
            <Typography variant='h3' gutterBottom display='block'>
                {t('site.issues.detailsTitle', { name: issue?.companyName })}
            </Typography>

            <Stack direction='row' spacing={4}>
                {issue && (
                    <IssueStatusDescription
                        hideUntil={issue.statusHideUntil}
                        stage={issue.statusStage}
                        isComplete={issue.statusComplete}
                    />
                )}
                <Typography variant='body1'>
                    <Link to={`/issues/${issueId}`}>[Visa detaljvy]</Link>
                </Typography>
                {issue?.companyId ? (
                    <Typography variant='body1'>
                        <Link to={`/companies/${issue?.companyId}`}>[Visa bolagsvy]</Link>
                    </Typography>
                ) : null}
            </Stack>

            <Divider sx={{ marginY: 6 }} />

            <Card sx={{ marginBottom: 6 }}>
                <CardContent>
                    {issueId === 'new' && <CreateIssueForm />}
                    {issueId !== 'new' && <EditIssueForm onChangeIssue={handleChangeIssue} issueId={issueId} />}
                </CardContent>
            </Card>
        </>
    )
}

export default AdminIssueForm
